import { HttpHeaders, provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, inject } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withPreloading,
  withViewTransitions
} from '@angular/router';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { environment } from '@environment';
import { NamedOptions, provideApollo, provideNamedApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { MAT_TAB_GROUP } from '@angular/material/tabs';
import { GraphqlApi } from '@core/api/graphql.api';
import { OccupationGraphqlApi } from '@core/api/occupation-graphql.api';
import { loaderInterceptor } from '@core/interceptors/loader.interceptor';

import { appRoutes } from './app.routes';
import { HighSchoolSalaryService } from './high-school-salary.service';
import { LoadingService } from './loading.service';
import { WidgetService } from './widget.service';
import { Window } from './tokens/window.token';
import { StepTitleStrategyService } from './v3/services/step-title-strategy.service';

export function createApollo(httpLink: HttpLink): ApolloClient.Options {
  return {
    link: httpLink.create({
      uri: environment.graphql,
      headers: new HttpHeaders({
        Tenant: window.location.hostname
      })
    }),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network'
      }
    }
  };
}

export function createNamedApollo(httpLink: HttpLink): NamedOptions {
  return {
    occupationGraphql: {
      link: httpLink.create({
        uri: environment.occupationGraphql
      }),
      cache: new InMemoryCache()
    }
  };
}

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withPreloading(PreloadAllModules),
      withEnabledBlockingInitialNavigation(),
      withComponentInputBinding(),
      withViewTransitions()
    ),
    provideHttpClient(withXhr(), withInterceptors([loaderInterceptor])),
    provideAnimations(),
    { provide: Window, useFactory: () => window },
    provideApollo(() => createApollo(inject(HttpLink))),
    provideNamedApollo(() => createNamedApollo(inject(HttpLink))),
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: 'always' }
    },
    {
      provide: MAT_TAB_GROUP,
      useValue: undefined
    },
    GraphqlApi,
    OccupationGraphqlApi,
    WidgetService,
    LoadingService,
    HighSchoolSalaryService,
    StepTitleStrategyService
  ]
};
